import { render, staticRenderFns } from "./No04.vue?vue&type=template&id=2765c9d6&scoped=true"
import script from "./No04.vue?vue&type=script&lang=js"
export * from "./No04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765c9d6",
  null
  
)

export default component.exports